var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "24px",
    viewBox: "0 0 26 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "26.5319824%",
    y1: "0%",
    x2: "103.094482%",
    y2: "151.546224%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFD7-Grundlagen:-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-955.000000, -1524.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atom/icon/24px/file-transfer",
    transform: "translate(955.000000, 1524.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00717596,12 L5.00717596,2 C5.00717596,1.44771525 5.45489121,1 6.00717596,1 L10.5128603,1 L10.5128603,1 L14.007176,4.95353266 L14.007176,12 C14.007176,12.5522847 13.5594607,13 13.007176,13 L6.00717596,13 C5.45489121,13 5.00717596,12.5522847 5.00717596,12 Z",
    id: "Fill-3",
    stroke: "#969899",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,22 L10,8 C10,7.44771525 10.4477153,7 11,7 L17.3409125,7 L17.3409125,7 L22,12.2713769 L22,22 C22,22.5522847 21.5522847,23 21,23 L11,23 C10.4477153,23 10,22.5522847 10,22 Z",
    id: "Fill-3",
    stroke: "#969899",
    strokeWidth: 2,
    fill: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,22 L10,8 C10,7.44771525 10.4477153,7 11,7 L17.3409125,7 L17.3409125,7 L22,12.2713769 L22,22 C22,22.5522847 21.5522847,23 21,23 L11,23 C10.4477153,23 10,22.5522847 10,22 Z",
    id: "Fill-3",
    stroke: "#969899",
    strokeWidth: 2,
    fill: "url(#linearGradient-1)",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 17,
    x2: 18,
    y2: 17,
    id: "Stroke-15",
    stroke: "#969899",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 13,
    x2: 16,
    y2: 13,
    id: "Stroke-13",
    stroke: "#969899",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98139178,20.0021252 C3.39839178,19.5921252 3.01839178,18.9101252 2.83639178,17.9901252 L3.84739178,17.9911252 C4.12239178,17.9911252 4.21739178,17.8081252 4.05939178,17.5831252 L2.35739178,15.1681252 C2.19939178,14.9441252 1.93939178,14.9441252 1.78039178,15.1671252 L0.0763917781,17.5761252 C-0.0816082219,17.8001252 0.0133917781,17.9851252 0.288391778,17.9851252 L1.30339178,17.9871252 L1.32839178,18.1191252 C1.56739178,19.5151252 2.16939178,20.5611252 3.11739178,21.2291252 C4.02939178,21.8701252 5.04339178,21.9921252 5.68239178,21.9921252 C6.05239178,21.9921252 6.29739178,21.9511252 6.32339178,21.9471252 C6.73139178,21.8751252 7.00339178,21.4871252 6.93239178,21.0781252 C6.86039178,20.6711252 6.47039178,20.3991252 6.06439178,20.4701252 C6.05239178,20.4701252 4.90139178,20.6511252 3.98139178,20.0021252 Z",
    id: "Fill-9",
    fill: "#969899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8792636,3.1063 C19.8922636,3.1063 21.0422636,2.9253 21.9622636,3.5743 C22.5452636,3.9843 22.9262636,4.6663 23.1072636,5.5863 L22.0972636,5.5853 C21.8212636,5.5843 21.7262636,5.7683 21.8852636,5.9933 L23.5862636,8.4083 C23.7442636,8.6323 24.0042636,8.6333 24.1622636,8.4083 L25.8662636,6.0003 C26.0252636,5.7753 25.9312636,5.5913 25.6552636,5.5913 L24.6402636,5.5893 L24.6152636,5.4573 C24.3762636,4.0613 23.7742636,3.0153 22.8262636,2.3473 C21.9142636,1.7063 20.9002636,1.5843 20.2612636,1.5843 C19.8912636,1.5843 19.6472636,1.6253 19.6202636,1.6293 C19.2122636,1.7013 18.9402636,2.0893 19.0112636,2.4983 C19.0832636,2.9053 19.4742636,3.1773 19.8792636,3.1063",
    id: "Fill-11",
    fill: "#969899"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTransfer);
export default __webpack_public_path__ + "static/media/file-transfer.8acc2dc2ca767b13368ea6ae1bbc9157.svg";
export { ForwardRef as ReactComponent };